import { Image } from '@perxis-auto/ui-kit/lib/components/Gallery';

import { IMedia } from '@/interfaces/grpc.interfaces';
import { ISettings } from '@/interfaces/settings.interfaces';
import getScrollbarWidth from '@/utils/getScrollbarWidth';

type Options = {
  media: ISettings['media'];
};

// 3 : 2
const IMAGE_SIZE = {
  preview: [160, 107],
  xxs: [320, 214],
  xs: [480, 320],
  sm: [640, 427],
  md: [960, 640],
} as const;

/**
 * Получить медиа-условия, описывающие свойства области просмотра
 * @param view Тип области просмотра
 * @returns {Array<string>} Массив медиа-условий, описывающих свойства области просмотра
 */
const getImageSizes = () => {
  const scrollbarWidth = getScrollbarWidth();

  // Значения массива зависят от сетки приложения
  const sizes: Array<string> = [];

  sizes.push(
    // Ширина картинки занимает ширину экрана без scrollbar минус левые и правые отступы от списка с авто.
    `(max-width: 575px) calc(((100vw - ${scrollbarWidth}px) - var(--perxis-auto-list-col-padding-right-inner) - var(--perxis-auto-list-col-padding-left-inner)) / 2)`,
  );

  return sizes;
};

/**
 * Формирует подготвленный объект изображения для Model Checkbox
 * @param marketingMedia объект автомобиля, используется для поиска данных по изображениям
 * @param options опции
 * @returns {Image} Картинка для Model Checkbox
 */
const getModelsImage = (marketingMedia: IMedia, options: Options): Image => {
  const { media } = options;

  const title = marketingMedia.name;
  const srcSet: Array<string> = [];

  if (!marketingMedia || !marketingMedia.file) {
    return {
      title,
    };
  }

  const original = `${media.apiRoot}/${marketingMedia.file.id}`;

  srcSet.push(
    `${original}?p=format-png&crop-${IMAGE_SIZE.xxs[0]}-${IMAGE_SIZE.xxs[1]} ${IMAGE_SIZE.xxs[0]}w`,
  );
  srcSet.push(
    `${original}?p=format-png&crop-${IMAGE_SIZE.xs[0]}-${IMAGE_SIZE.xs[1]} ${IMAGE_SIZE.xs[0]}w`,
  );
  srcSet.push(
    `${original}?p=format-png&crop-${IMAGE_SIZE.sm[0]}-${IMAGE_SIZE.sm[1]} ${IMAGE_SIZE.sm[0]}w`,
  );
  srcSet.push(
    `${original}?p=format-png&crop-${IMAGE_SIZE.md[0]}-${IMAGE_SIZE.md[1]} ${IMAGE_SIZE.md[0]}w`,
  );
  srcSet.push(`${original} 1800w`);

  const sizes = getImageSizes();
  const thumbnail = `${original}?p=format-png&crop-${IMAGE_SIZE.preview[0]}-${IMAGE_SIZE.preview[1]}`;

  return {
    original,
    thumbnail,
    ...(srcSet.length ? { srcSet: srcSet.join(',') } : {}),
    ...(sizes.length ? { sizes: sizes.join(',') } : {}),
    title,
  };
};

export default getModelsImage;
